import { espoAppDB } from "../storage/espoAppDB";

export type DraftRecord<T> = {
  data: T;
  updatedAt: number;
};

const DRAFT_PREFIX = "draft:";

export const buildDraftKey = (
  ...parts: Array<string | number | null | undefined>
) => {
  const suffix = parts
    .filter((part) => part !== null && part !== undefined && `${part}`.length > 0)
    .join(":");
  return `${DRAFT_PREFIX}${suffix}`;
};

export const loadDraft = async <T>(
  key: string,
): Promise<DraftRecord<T> | null> => {
  if (!key) return null;
  try {
    const entry = await espoAppDB.getDraft<DraftRecord<T>>(key);
    if (entry?.data) {
      return entry.data;
    }
  } catch (error) {
    console.error("Failed to load draft from EspoAppDB:", error);
  }
  return null;
};

export const saveDraft = async <T>(key: string, data: T) => {
  if (!key) return;
  const record: DraftRecord<T> = {
    data,
    updatedAt: Date.now(),
  };
  try {
    await espoAppDB.setDraft(key, record);
  } catch (error) {
    console.error("Failed to save draft to EspoAppDB:", error);
  }
};

export const clearDraft = async (key: string) => {
  if (!key) return;
  try {
    await espoAppDB.deleteDraft(key);
  } catch (error) {
    console.error("Failed to delete draft from EspoAppDB:", error);
  }
};
